import { useLayoutEffect } from 'react'

import { PdfViewerEvent } from '../../PdfViewer.constants'

import { createPdfViewerInstance } from './usePdfViewer.utils'

export function usePdfViewerInstance({
  containerRef,
  eventBusRef,
  findControllerRef,
  pdfViewerRef,
  rootRef,
  selectAreaLayerRef,
  setPdfViewerInstance,
  singlePage = false,
  viewerElementRef,
  viewerRootRef,
  onPageChanging,
  onPageRendered,
  onPagesInit,
  onScaleChanging,
}) {
  // a layout effect: the sibling hooks read the refs in their passive effects,
  // whatever order they are called in
  useLayoutEffect(() => {
    const { eventBus, findController, pdfViewer } = createPdfViewerInstance({
      container: containerRef.current,
      singlePage,
      viewer: viewerElementRef.current,
    })

    eventBus.on(PdfViewerEvent.PagesInit, () => {
      onPagesInit(pdfViewer)
    })
    eventBus.on(PdfViewerEvent.PageChanging, event => {
      onPageChanging(event, pdfViewer)
    })
    eventBus.on(PdfViewerEvent.ScaleChanging, onScaleChanging)
    eventBus.on(PdfViewerEvent.PageRendered, onPageRendered)

    eventBusRef.current = eventBus
    pdfViewerRef.current = pdfViewer
    findControllerRef.current = findController

    if (viewerRootRef) {
      viewerRootRef.current = rootRef.current
    }

    setPdfViewerInstance?.({
      container: containerRef.current,
      eventBus,
      pdfViewer,
      selectAreaLayer: selectAreaLayerRef.current,
    })

    return () => {
      setPdfViewerInstance?.(null)

      pdfViewerRef.current = null
      eventBusRef.current = null
      findControllerRef.current = null
    }
  }, [])
}
